import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-thirty-three',
  templateUrl: './home-thirty-three.component.html',
  styleUrls: ['./home-thirty-three.component.scss']
})
export class HomeThirtyThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
